// Sortable
import { moveItemInList } from 'mdb-sortable';
// tables
import {
  Component, OnInit, ElementRef, HostListener,
  AfterViewInit, ViewChild, ChangeDetectorRef,
  QueryList, ViewChildren, EventEmitter, Output
} from '@angular/core';
import { MdbTableDirective, MdbTablePaginationComponent, MdbBtnDirective, MDBModalRef } from 'ng-uikit-pro-standard';
// mensage type  toast
import { ToastService } from 'ng-uikit-pro-standard';
// forms and validations
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { ComponentsType, ComponentIndicator, ComponentChart, ChartDatasets, ChartColors, Dashboard } from 'src/app/models/component-data';
import { DasboardService } from 'src/app/services/dashboard.service';
import { TranslateService } from '@ngx-translate/core';
import { groupBy, mergeMap, toArray } from 'rxjs/operators';
import { from, Observable } from 'rxjs';
import { GetTypePipe } from 'src/app/custom-pipe/GetTypePipe';
import { AppConfigService } from 'src/app/app-config.service.service';
import { ProjectService } from 'src/app/services/project.service';
import { DatePipe } from '@angular/common';
import { GeneralService } from 'src/app/services/general.service';
import { Router } from '@angular/router';
import { MapInformationService } from 'src/app/services/map-information.service';

@Component({
  selector: 'add-edit-workflow',
  templateUrl: './add-edit-workflow.component.html',
  styleUrls: ['./add-edit-workflow.component.scss']
})
export class AddEditWorkFlowComponent implements OnInit {
  @Output() onsave: EventEmitter<any> = new EventEmitter<any>();
  @Output() CloseModal: EventEmitter<any> = new EventEmitter<any>();
  viewTypeCard = 0;
  gridDataSource;
  GridShow: any;
  columns: any[] = [];
  dateFormat = 'dd-MM-yyyy';
  moneyFormat = '';



  segmentSelected = 2;
  segmentItems: any[] = [
    // {
    //   Id: 1,
    //   Name: 'Status'
    // },
    {
      Id: 2,
      Name: 'Phases'
    }
  ]
  ProjectPhases = [];
  ProjectStatus = [];
  DataList = []
  popup_bool: boolean = false;
  popup_bool_list: boolean = false;
  editinsert_SP: boolean = null;
  FormEditPhase: FormGroup;
  FormEditStatus: FormGroup;
  filterValue = [
    ['StatusName', '=', 'Not Started'],
    'or',
    ['StatusName', "=", 'In Progress']
  ];
  lists: any[] = [];
  statuses: string[];
  ProyectsGrouped: any = [];

  DataPS = {
    Phase: [],
    Status: []
  }

  HabilitarModal: boolean = false
  allWorkFlow: any[] = []
  Phases:any[]=[]


  constructor(
    private ProjectService: ProjectService,
    private datePipe: DatePipe,
    private translateService: TranslateService,
    // private translatePipe: TranslatePipe,
    private appConfigService: AppConfigService,
    public generalService: GeneralService,
    private toast: ToastService,
    private router: Router,
    public MapInformationService: MapInformationService,) {

    this.dateFormat = this.appConfigService.dateFormat;
    this.moneyFormat = this.appConfigService.moneyFormat;

  }

  ngOnInit() {
    const data = {
      method:"Get_ProjectWorkFlowUtility"
    }
    this.MapInformationService.SaveInfoSites(data)
    .subscribe(info=>{
      this.ProjectService.Get_ProjectPhasesCE()
      .subscribe(resp => {
        this.Phases = resp
        this.allWorkFlow = info
        console.log(resp)
        console.log(info)
          this.HabilitarModal = true
      })
    })
  }

  /********************* */
  save_edit(event) {
    this.popup_bool = false;
    this.popup_bool_list = false;
    let item = event.data;
    console.log(item)
    console.log(event)
    let contador = 0

    if(item.WORKFLOWNAME == undefined){
      this.toast.warning("Required Name")
      contador++
    } else if (item.DESCRIPTION == undefined){
      this.toast.warning("Required Description")
      contador++
    } else if (item.SORT == undefined){
      this.toast.warning("Required Sort")
      contador++
    } else if (item.PROJECTFLOWPHASEID == undefined){
      this.toast.warning("Required Phase ID")
      contador++
    }  
    
    if (item.ParentID == undefined){
      item.ParentID = 0
    } 
    
    if (item.DaysformContract == undefined){
      item.DaysformContract = 0
    } 
    
    if (item.Daysfromparent == undefined){
      item.Daysfromparent = 0
    } 

    if(contador == 0){
      const data = {
        id:0,
        workflowname:item.WORKFLOWNAME,
        description:item.DESCRIPTION,
        enable:item.ENABLE == true ? 1:0,
        projectflowphaseid:item.PROJECTFLOWPHASEID,
        sort:item.SORT,
        active:item.ENABLE == true ? 1:0,
        daysfromcontract:item.DaysformContract,
        daysfromparent:item.Daysfromparent,
        parentid:item.ParentID,
        method:"Get_InserUpdateUtilityProjectWorkFlow"
      }
      console.log(data)
      
      this.MapInformationService.SaveInfoSites(data)
      .subscribe(resp => {
        console.log(resp)
        this.toast.success("Successfully Created")
        this.onsave.emit("test");
      })
    }

  }

  update(obj) {
    let olddata = obj.oldData;
    let newData = obj.newData;
    let item = obj.newData
    console.log(newData)
    console.log(olddata)
    if(item.WORKFLOWNAME == undefined){
      item.WORKFLOWNAME = olddata.WORKFLOWNAME
    } 
    
    if (item.DESCRIPTION == undefined){
      item.DESCRIPTION = olddata.DESCRIPTION
    } 
    
    if (item.SORT == undefined){
      item.SORT = olddata.SORT
    } 
    
    if (item.PROJECTFLOWPHASEID == undefined){
      item.PROJECTFLOWPHASEID = olddata.PROJECTFLOWPHASEID
    } 
    if (item.ENABLE == undefined){
      item.ENABLE = olddata.ENABLE
    }
    
    if (item.ParentID == undefined){
        item.ParentID = olddata.ParentID
    } 
    
    if (item.DaysformContract == undefined){
      item.DaysformContract = olddata.DaysformContract
    } 
    
    if (item.Daysfromparent == undefined){
      item.Daysfromparent = olddata.Daysfromparent
    } 
    
    const data = {
      id:olddata.ID,
      workflowname:item.WORKFLOWNAME,
      description:item.DESCRIPTION,
      enable:item.ENABLE == true ? 1:0,
      projectflowphaseid:item.PROJECTFLOWPHASEID,
      sort:item.SORT,
      active:item.ENABLE == true ? 1:0,
      daysfromcontract:item.DaysformContract,
      daysfromparent:item.Daysfromparent,
      parentid:item.ParentID,
      method:"Get_InserUpdateUtilityProjectWorkFlow"
    }
    console.log(data)
    this.MapInformationService.SaveInfoSites(data)
    .subscribe(resp => {
      console.log(resp)
      this.toast.success("Successfully updated")
      this.onsave.emit("test");
    })
    
  }

  ActulizarGrid(){
    const data = {
      method:"Get_ProjectWorkFlowUtility"
    }
    this.MapInformationService.SaveInfoSites(data)
    .subscribe(info=>{
      this.allWorkFlow = info
    })
  }

  CerrarModal(){
    this.HabilitarModal = false
    this.CloseModal.emit("cerrar")
  }

}
